// extracted by mini-css-extract-plugin
module.exports = {"content-wrapper":"_1MQQBs8CBrE3Vc8IdbsUZu","text-has-recipe":"_2KDtL5BrdFoMbsXwKLQsP6","text-manage":"v1zD6R98CgH-MNblhSIKp","recipe-icon":"dPcsK_jY6GQkvQilceNJn"};